import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { GetTeamInputSchema } from './get-team.models.ts'
import { ListTeamsInputSchema } from './list-teams.models.ts'

export const QueryInputSchema = z.union([
  GetTeamInputSchema,
  ListTeamsInputSchema,
])

export type QueryInput = ZodInfer<typeof QueryInputSchema>

export const QueryWhereSchema = GetTeamInputSchema.extend(
  ListTeamsInputSchema.shape
).partial()

export type QueryWhere = ZodInfer<typeof QueryWhereSchema>
